import { useMediaQuery } from 'usehooks-ts';

export const DESKTOP_BREAKPOINT = 768;

export const useIsDesktop = () => useMediaQuery(`(min-width: ${DESKTOP_BREAKPOINT}px)`);
